<template>
    <div class="grade_item-container">
        <h2 class="grade_item-name">Результаты прохождения</h2>
        <v-card v-for="(row, rowIndex) in rows" :key="rowIndex" class="row-card">
            <v-card-text class="row-card-text">
                <v-row>
                    <v-col cols="12" class="cell-expand cell-label">
                        <span class="txt-header">
                            {{ row.testName }}
                        </span>
                        <v-icon @click="toggleExpand(row)" class="cell-expand-icon">
                            {{ expanded === row.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                    </v-col>
                    <v-col cols="12" class="cell-value">
                        <span><span class="txt-label">Последний результат</span> {{ `${row.results && row.results.length > 0 ? row.results[0].score : ''}` }}</span>
                    </v-col>
                    <v-col v-show="expanded === row.id" cols="12">
                        <v-row>
                            <v-col cols="12" sm="6" class="cell-label">Вид теста</v-col>
                            <v-col cols="12" sm="6" class="cell-value">
                                {{ row.passTypeName }}
                            </v-col>
                            <v-col cols="12" sm="6" class="cell-label">Тип теста</v-col>
                            <v-col cols="12" sm="6" class="cell-value">
                                {{ getTestTypeName(row.testType) }}
                            </v-col>
                            <v-col cols="12" sm="6" class="cell-label">Дисциплина</v-col>
                            <v-col cols="12" sm="6" class="cell-value">
                                {{ row.subjectName }}
                            </v-col>
                            <v-col cols="12" sm="6" class="cell-label">Тема</v-col>
                            <v-col cols="12" sm="6" class="cell-value">
                                {{ row.topicName }}
                            </v-col>
                            <v-col cols="12" sm="6" class="cell-label">Количество прохождений</v-col>
                            <v-col cols="12" sm="6" class="cell-expand cell-value">
                                <a href="#" @click.prevent="toggleResult">
                                    {{ `${row.results ? row.results.length : ''}` }}
                                </a>
                                <v-icon @click="toggleResult" class="cell-expand-icon">
                                    {{ resultOpened ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                </v-icon>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col
                        v-if="row.results && row.results.length > 0"
                        v-show="expanded === row.id && resultOpened"
                        class="cell-result ml-4"
                    >
                        <v-row v-for="(result, resultIndex) in row.results" :key="resultIndex">
                            <v-col cols="12">
                                <v-row >
                                    <v-col cols="6" sm="4" class="cell-label">Дата прохождения</v-col>
                                    <v-col cols="6" sm="3" class="cell-label">Результат</v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="4" class="cell-value">
                                        {{ result.passDateShort }}
                                    </v-col>
                                    <v-col cols="6" sm="3" class="cell-value">
                                        <v-progress-circular
                                            :value="result.score"
                                            :color="getScoreColor(result.score)"
                                            :size="33"
                                            :width="4"
                                            class="mr-2"
                                        ></v-progress-circular>
                                        <span>{{ `${result.score}%` }}</span>
                                    </v-col>
                                    <v-col cols="12" sm="5" class="cell-value">
                                        <v-btn v-if="row.testType === 0"
                                            @click.stop="learningResultDialog.open(row.userId, row.testId, result.id)"
                                            :loading="learningResultDialog.loading && learningResultDialog.id === result.id"
                                            :disabled="learningResultDialog.loading && learningResultDialog.id !== result.id"
                                            class="btn"
                                        >
                                            Просмотр результатов
                                        </v-btn>
                                        <v-btn v-else-if="row.testType === 1"
                                            @click.stop="diagnosticsResultDialog.open(row.userId, row.testId, result.id); saveIdResult(result.id)"
                                            :loading="diagnosticsResultDialog.loading && diagnosticsResultDialog.id === result.id"
                                            :disabled="diagnosticsResultDialog.loading && diagnosticsResultDialog.id !== result.id"
                                            class="btn"
                                        >
                                            Просмотр результатов
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { helpers } from '@/store/tests';
import { mapMutations } from 'vuex'

export default {
    name: 'ResultsTableMobile',
    props: {
        learningResultDialog: Object,
        diagnosticsResultDialog: Object
    },
    data: () => ({
        rows: [],
        expanded: null,
        resultOpened: false
    }),
    methods: {
        ...mapMutations({
            saveIdResult: 'diagnosticTest/saveIdResult'
        }),
        update(data) {
            this.rows = data.data[0].rows;
        },
        getTestTypeName(type) {
            return helpers.testTypes[type];
        },
        getScoreColor(score) {
            return helpers.getScoreColor(score);
        },
        toggleExpand(row) {
            if (this.expanded === row.id) {
                this.expanded = null;
            } else {
                this.expanded = row.id;
            }

            this.resultOpened = false;
        },
        toggleResult() {
            this.resultOpened = !this.resultOpened;
        }
    },
    created(){
        console.log('mobile');
    }
}
</script>

<style scoped lang="scss">
@import './mobileView.scss';
</style>
